"use client";

import { useEffect, useRef } from "react";

import { getCookiebotDomainGroupId } from "@/utilities/cookiebotDomainGroupId";

/**
 * Cookiebot Cookie Declaration (`cd.js`). Embed on the page where the declaration should appear.
 *
 * @see https://www.cookiebot.com/en/developer/
 */
export function CookieDeclarationScript() {
  const cbid = getCookiebotDomainGroupId();
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!cbid || !containerRef.current) return;

    const container = containerRef.current;
    container.innerHTML = "";

    const script = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src = `https://consent.cookiebot.com/${cbid}/cd.js`;
    script.type = "text/javascript";
    script.async = true;

    container.appendChild(script);

    return () => {
      container.innerHTML = "";
    };
  }, [cbid]);

  if (!cbid) {
    return null;
  }

  return <div ref={containerRef} />;
}
